import {
    Crossword1,
    Crossword2,
    Crossword3,
    Crossword4,
    Crossword5,
    Crossword6,
    Crossword7,
    Crossword8,
    Crossword9,
    Crossword12,
} from './Crosswords';
import Config from 'config';
import { Crossword14 } from './Crosswords/Crossword14';

export const Crossword1Data = {
    crossword: Crossword1,
    image: `${Config.themePath}/images/crosswords/crossword-1.jpg`,
    horizontal: [
        '1. Estilo de gestión que busca replicar el comportamiento de un índice',
        '3. Recuperar la inversión realizada en un plan de pensiones',
        '4. Índice al que están referenciadas la mayoría de hipotecas',
        '7. No poner todos los huevos en la misma cesta',
        '9. Método para determinar qué participaciones de un fondo se venden primero',
        '11. Relación entre el precio en bolsa de una compañía y el beneficio neto anual',
        '12. Empresa que hace banca pero sólo vía online, lo que le permite trasladar menos costes al cliente',
        '14. Valor añadido que aporta un gestor con respecto al índice',
        '15. Indicador que permite medir la evolución de un mercado en su conjunto',
    ],
    vertical: [
        '2. Comprar participaciones de un fondo de inversión',
        '5. Apellido del personaje que aparece en la foto',
        '6. Nombre del personaje que aparece en la foto',
        '8. Comisión que cobran algunos fondos en función de la rentabilidad obtenida',
        '10. Tipo de cuenta en la que el titular es el intermediario financiero',
        '13. Estrategia que se caracteriza por invertir a contracorriente del sentimiento general del mercado',
    ],
};

export const Crossword2Data = {
    crossword: Crossword2,
    image: `${Config.themePath}/images/crosswords/crossword-2.jpg`,
    horizontal: [
        '5. Principal índice de la bolsa española',
        '7. Empresa de servicios financieros que analiza fondos de inversión y les otorga un rating',
        '8. Estilo de gestión cuyo objetivo es batir al índice',
        '9. Ratio que mide los gastos totales de un fondo',
        '11. Entidad que asume la custodia de los activos en los que invierte un fondo',
        '13. Subida prolongada de un activo a precios que difieren de su valor intrínseco',
        '14. Filosofía de inversión que busca valores con perspectivas de crecimiento por encima de la media',
        '15. Beneficio antes de intereses, impuestos, depreciaciones y amortizaciones',
    ],
    vertical: [
        '1. Acontecimiento que da lugar al cobro de la prestación en un plan de pensiones',
        '2. Venta de las participaciones de un fondo de inversión',
        '3. Empresa que usa las nuevas tecnologías para desarrollar nuevos productos o servicios financieros',
        '4. Nombre del personaje que aparece en la foto',
        '6. Apellido del personaje que aparece en la foto',
        '10. Siglas de la directiva europea que permite a los fondos operar de forma transfronteriza',
        '12. Cambiar alguno de los titulares de un préstamo, ya sea la entidad o el deudor del mismo',
    ],
};

export const Crossword3Data = {
    crossword: Crossword3,
    image: `${Config.themePath}/images/crosswords/crossword-3.jpg`,
    horizontal: [
        '1. Variable que mide la pérdida máxima que puede asumir un fondo en un periodo determinado',
        '3. Nombre del personaje que aparece en la foto',
        '4. Beneficio que una empresa distribuye entre sus accionistas',
        '6. Producto Interior Bruto de un país',
        '7. Principal índice de la bolsa alemana',
        '9. Bienes y derechos de los que la empresa puede disponer a corto plazo',
        '10. Apellido del personaje que aparece en la foto',
        '13. Neobanco experto en inversión participado por Andbank, El Corte Inglés y AXA',
        '15. Derechos económicos que recibirá el beneficiario de un plan de pensiones',
    ],
    vertical: [
        '2. Empresa que presta un servicio de gestión de carteras vía online y de forma automatizada',
        '5. Modalidad de rescate de un plan de pensiones que permite cobrar en un solo pago',
        '8. Filosofía de inversión que busca compañías que cotizan por debajo de su valor intrínseco',
        '11. Compañía que tiene como objeto social la gestión y administración de fondos de inversión',
        '12. Venta de participaciones de un fondo para comprar participaciones por la misma cuantía en otro',
        '14. Estrategia de inversión que busca replicar el comportamiento de un determinado índice',
    ],
};

export const Crossword4Data = {
    crossword: Crossword4,
    image: `${Config.themePath}/images/crosswords/crossword-4.jpg`,
    horizontal: [
        '6. Divisa digital que utiliza la criptografía para asegurar las transacciones',
        '7. Contrato bancario en el que se registran el balance y los movimientos de dinero del cliente',
        '9. Siglas del organismo que supervisa y regula los planes de pensiones',
        '11. Conjunto de operaciones que se realizan sobre una cartera para reajustar su perfil de riesgo',
        '13. Tipo de interés que indica el coste efectivo de un producto financiero',
        '15. Subida generalizada de los precios durante un periodo determinado',
    ],
    vertical: [
        '1. Persona que coloca su dinero en un fondo de inversión',
        '2. Fondo de inversión cuya cartera está compuesta por diferentes tipos de activos',
        '3. Gestora estadounidense que cuenta con el mayor volumen de activos a nivel mundial',
        '4. Apellido del personaje que aparece en la foto',
        '5. Nombre del personaje que aparece en la foto',
        '8. Índice de referencia del sector tecnológico en Estados Unidos',
        '10. Compañía cotizada que opera con inmuebles con el objetivo de generar rentas',
        '12. Situación en la que los gastos realizados por un Estado superan a los ingresos no financieros',
        '14. Tipo de préstamo en el que el cliente pone como garantía de pago una propiedad que tenga',
    ],
};

export const Crossword5Data = {
    crossword: Crossword5,
    image: `${Config.themePath}/images/crosswords/crossword-5.jpg`,
    horizontal: [
        '4. Categoría de fondo de inversión de riesgo muy bajo',
        '5. Organismo que regula y supervisa los mercados de valores en España',
        '7. Metal precioso considerado como un valor refugio',
        '8. Gestora fundada por John Bogle, referencia en el ámbito de la gestión pasiva',
        '9. Situación en la que un trabajador solicita la inactividad laboral, tras llegar a la edad establecida',
        '10. Nombre del personaje que aparece en la foto',
        '12. Apellido del personaje que aparece en la foto',
        '14. Relación entre el importe que inviertes y las ganancias que obtienes',
        '15. Documento que detalla las características de un fondo de inversión',
    ],
    vertical: [
        '1. Institución de inversión colectiva que, a diferencia de un fondo, tiene carácter societario',
        '2. Emisión de deuda, pública o privada, que suele negociarse en un mercado de valores',
        '3. Tributo que grava la renta de las personas residentes en España durante un año natural',
        '6. Oscilación en el precio de un activo financiero en un periodo determinado',
        '11. Capacidad de una inversión para convertirse en efectivo de forma inmediata y sin perder valor',
        '13. Índice principal de la bolsa europea',
    ],
};

export const Crossword6Data = {
    crossword: Crossword6,
    image: `${Config.themePath}/images/crosswords/crossword-6.jpg`,
    horizontal: [
        '6. Loan to value. Relación entre el importe prestado y el valor del inmueble',
        '7. Apellido del gestor del fondo MyInvestor Value',
        '8. Familia de índices bursátiles creada por Morgan Stanley Capital Internacional',
        '9. Vigilia navideña y uno de los cinco festivos para la bolsa española en 2021',
        '11. Nombre del personaje que aparece en la foto (barba castaña)',
        '12. Nombre del personaje de la foto (barba blanca)',
        '14. Mecanismo de financiación colectiva con el que numerosos ahorradores unen fuerzas para invertir en un proyecto',
        '15. Época propicia para estar con los seres queridos... y aportar a un plan de pensiones antes de que acabe el año',
    ],
    vertical: [
        '1. Poner algo como garantía de un préstamo. Dejar algo en prenda',
        '2. Entidad galardonada como la mejor fintech de 2021 en los Premios Expansión Start Up 2021',
        '3. Clase de fondo de inversión en la que los rendimientos generados se reinvierten en el propio fondo',
        '4. Termita que va devorando poco a poco tus ahorros, a menos que los inviertas',
        '5. Invertir en distintos activos/mercados para optimizar el riesgo. No poner todos los huevos en la misma cesta',
        '10. Nombre del personaje que aparece en la foto (barba negra)',
        '13. Producto no regulado sobre el que la CNMV advirtió a Andrés Iniesta',
    ],
};
export const Crossword7Data = {
    crossword: Crossword7,
    image: `${Config.themePath}/images/crosswords/crossword-7.png`,
    horizontal: [
        '2. Código que sirve para identificar acciones de una empresa cotizada',
        '3. Apellido del gestor de Baelo Patrimonio',
        '5. Cada una de las partes iguales en las que se divide el capital de una compañía',
        '6. Dejar en prenda algún tipo de activo, poniéndolo como garantía de un préstamo',
        '7. Instrumento que emite una empresa/gobierno para financiarse. También el cantante de un grupo musical',
        '10. Índice de la bolsa japonesa',
        '11. Variable que abarca todas las comisiones y gastos de un fondo (salvo suscripción/reembolso)',
        '12. Acción de ingresar dinero en un plan de pensiones',
        '15. Indicador que vuelve a traer de cabeza a los clientes de hipotecas a tipo variable',
    ],
    vertical: [
        '1. Beneficio que una empresa distribuye entre sus accionistas',
        '4. Recurrir al endeudamiento para aumentar la cantidad de dinero invertido. O ponerse muy cómodo.',
        '8. Apellido del cogestor de MyInvestor Cartera Permanente',
        '9. Coyuntura en la que una inflación elevada convive con un estancamiento económico',
        '12. Gestora francesa que destaca entre las firmas de referencia en productos indexados',
        '14. Aquello que guía a los Reyes Magos (y a los inversores en fondos que consultan Morningstar)',
    ],
};

export const Crossword8Data = {
    crossword: Crossword8,
    image: `${Config.themePath}/images/crosswords/crossword-8.png`,
    horizontal: [
        '5. Apellido del personaje de la foto',
        '6. Tipo de cartera que, siguiendo el modelo de Harry Browne, permite adaptarse a todos los ciclos de mercado',
        '9. Siglas del fondo que garantiza cuentas y depósitos hasta 100.000 euros por titular y entidad',
        '11. Dejar en prenda algún tipo de activo, poniéndolo como garantía de un préstamo',
        '13. Fintech que presta (todos o algunos) servicios bancarios. Algunos, como MyInvestor, tienen licencia bancaria',
        '15. Compañía pequeña que cotiza a bajo precio. Pista: se mueve más en bolsa que cierto pececillo',
    ],
    vertical: [
        '1. Nombre del personaje de la foto',
        '2. Producto en el que el dinero queda inmovilizado a cambio de un interés. Los de MyInvestor son muy jugosos. ',
        '3. Intermediario financiero que tramita las operaciones de compraventa del cliente',
        '4. Emisión de deuda pública a muy corto plazo. También es uno de los signos que componen el alfabeto',
        '7. Fondo cotizado. Es un híbrido entre un fondo de inversión y una acción',
        '8. Tipo de test que evalúa los objetivos y carácterísticas deun inversor para determinar su perfil de riesgo',
        '10. Categoría de fondos con el riesgo más bajo. Sólo invierte en activos monetarios o emisiones a muy corto plazo',
        '12. Producto en el que el dinero queda inmovilizado a cambio de un interés. Los de MyInvestor son muy jugosos. ',
        '13. Contrato por el que una aseguradora se compromete a cubrir un riesgo, a cambio del cobro de una prima',
    ],
};

export const Crossword9Data = {
    crossword: Crossword9,
    image: `${Config.themePath}/images/crosswords/crossword-9.png`,
    horizontal: [
        '5. Endeudarse para aumentar la cantidad de dinero invertido. O ponerse muy cómodo',
        '8. Adorno navideño (en la imagen)',
        '10. Regalo que Baltasar llevó al Niño Jesús (no sabemos si en forma de ETF)',
        '11. Apellido de un cantante de Operación Triunfo que es fan del interés compuesto',
        '12. Fondo de capital riesgo que invierte en negocios maduros',
        '14. Categoría de fondo de inversión de muy bajo riesgo y gran liquidez',
        '15. Test que mide si un producto es adecuado para un determinado cliente',
    ],
    vertical: [
        '1. Apellido del socio de Warren Buffett que murió recientemente a los 99 años',
        '2. Tipo de análisis de valores que se centra en los patrones que forma la cotización',
        '3. Estrategia que consiste en invertir la misma cantidad, de forma periódica',
        '4. Subidón que pegan las bolsas (o no) en los últimos días del año',
        '6. Índice que recoge la evolución de las bolsas de países desarrollados y emergentes',
        '7. Apellido del cogestor de Mylnvestor Cartera Permanente, junto a Rafa Ortega',
        '9. Apellido (sin el guión) del gestor del fondo Myinvestor Value',
        '13. Carteras compuesta por fondos de gestión activa y pasiva, como las de Finanbest',
    ],
};

export const Crossword12Data = {
    crossword: Crossword12,
    image: `${Config.themePath}/images/crosswords/crossword-12.png`,
    horizontal: [
        '2. Los hay con forma de patito, de flamenco y redondos como un donut (en la imagen)',
        '4. Gestora con la que se ha aliado Myinvestor para el lanzamiento de su fondo de dividendos',
        '6. El tipo de cuenta corriente que más te interesa. O, al menos, que más interés te da.',
        '7 . Se dice de este interés que es la octava maravilla del mundo',
        '9. Nombre en inglés de un color. También de la Cartera Híbrida Finanbest de menor riesgo',
        '11. Ratio que permite medir la rentabilidad de un fondo con respecto al riesgo asumido',
        '13. Test que hay que realizar antes de contratar un fondo de capital riesgo',
        '14. Evento que puede provocar una rápida reacción en la cotización de un valor',
    ],
    vertical: [
        '1. Nombre de un famoso pato y de un no menos famoso presidente de los EEUU',
        '3. Oscilación en el precio de un activo en un periodo determinado. Es el termómetro del riesgo',
        '5. Instrumento musical en el que es muy ducho Warren Buffett',
        '8. Dato clave para comparar el interés de depósitos (o hipotecas)',
        '10. Según Benjamin Franklin, lo único que es inevitable, además de la muerte',
        '12. Como un fondo de inversión, pero con formato de sociedad',
    ],
};

export const Crossword14Data = {
    crossword: Crossword14,
    image: `${Config.themePath}/images/crosswords/crossword-14.png`,
    horizontal: [
        '1. Plataforma de IA. Es una de las tres que permiten acceder a información de productos MyInvestor',
        '3. Autor de la frase: "No busques la aguja, cómprate el pajar"',
        '5. Sistema electrónico de negociación de la Bolsa de Fráncfort',
        '6. Directiva europea que establece los requisitos para ejercer como asesor financiero',
        '8. Llevar la hipoteca de un banco a otro con mejores condiciones',
        '9. Producto de ahorro a plazo fijo (muy preferible al cerdito)',
        '13. Objeto rectangular de material elástico debajo del cual no es recomendable colocar tus ahorros',
        '14. Movimiento de dinero de un fondo de inversión a otro sin pagar impuestos por el camino',
    ],
    vertical: [
        '2. Cartera de fondos que está gestionada por un roboadvisor',
        '4. Seminario online que puede centrarse en diversos temas. Entre ellos, educación financiera',
        '7. Maná bursátil. Parte del beneficio que se reparte a los accionistas',
        '10. Compañía tecnológica protagonista de la mayor salida a bolsa de la historia',
        '11. Mueble de playa en el que apalancarse… en sentido literal, no financiero (en la imagen)',
        '12. Localidad catalana que da nombre al equipo de fútbol patrocinado por MyInvestor',
    ],
};

export default {
    Crossword1Data,
    Crossword2Data,
    Crossword3Data,
    Crossword4Data,
    Crossword5Data,
    Crossword6Data,
    Crossword7Data,
    Crossword8Data,
    Crossword9Data,
    Crossword12Data,
    Crossword14Data,
};
